import { render, staticRenderFns } from "./sumsub.vue?vue&type=template&id=abd427f2"
import script from "./sumsub.vue?vue&type=script&lang=js"
export * from "./sumsub.vue?vue&type=script&lang=js"
import style0 from "./sumsub.vue?vue&type=style&index=0&id=abd427f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports